<template>
  <div
    class="quincy-wrapper__controls__trash-button"
    @click="deleteSymptom"
    @mouseover="active = true"
    @mouseleave="active = false"
    v-tippy="{ placement: 'right', content: $t('components.quincy.buttons.remove') }"
    data-cy="quincy-controls-delete"
  >
    <trash-vue :selected="active"></trash-vue>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { MUTATIONS, GETTERS } from '../../store/quincy/definitions';
import TrashVue from './controls/Trash.vue';

export default {
  components: {
    TrashVue
  },
  props: {
    display: Boolean
  },
  data() {
    return {
      active: false
    };
  },
  methods: {
    ...mapMutations('quincy', {
      $REMOVEDRAWING: MUTATIONS.REMOVE_ENTIRE_DRAWING
    }),
    deleteSymptom() {
      this.$REMOVEDRAWING(this.$ACTIVESYMPTOM);
    }
  },
  computed: {
    ...mapGetters('quincy', {
      $ACTIVESYMPTOM: GETTERS.ACTIVE_SYMPTOM
    })
  }
};
</script>

<style lang="css"></style>
